// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cards_cards__3YuUu {\n  display: flex;\n  height: 20px;\n}\n.cards_cards__3YuUu svg {\n  margin-left: 10px;\n}", ""]);
// Exports
exports.locals = {
	"cards": "cards_cards__3YuUu"
};
module.exports = exports;
